export default __webpack_public_path__ + "static/media/portfolio-submenu.84eb50e2.webp";